import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { LoadingButtonModule } from '@ui/loading-button/loading-button.module';
import { ProfilesCompanyComponent } from './profiles-company.component';
import { ServicePermissionsComponent } from './components/service-permissions/service-permissions.component';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [ProfilesCompanyComponent, ServicePermissionsComponent],
    imports: [
        CommonModule,
        TranslateModule,
        PerfectScrollbarModule,
        LoadingButtonModule,
        RouterModule,
        FormsModule,
    ],
    exports: [ProfilesCompanyComponent],
})
export class ProfilesCompanyModule {}
